module.exports = __webpack_public_path__ + "img/receipt.18038c81.svg";